import React, {useEffect, useState} from 'react';
import {Formik} from 'formik';
import {useRouteMatch} from 'react-router-dom';
import Form_1View from './Form_1-view';
import SilentSubmitHandler from '../SilentSubmitHandler';
import {checkRequiredValues} from '../../../../common/utils/form/checkRequiredValues';
import {normalizeFormValues} from '../../../../common/utils/form/normalizeFormValues';
import {getFileFromDataURI} from '../../../../common/utils/files/getFileFromDataURI';
import {pathnames as P} from '../../../../common/constants/pathnames';
import {fileTypeId as T} from '../../constants/fileTypeId';
import {isFileUploaded} from '../../utils/isFileUploaded';
import {
  rightsTypeOptions,
  attachedOptions,
  rightsRegistryRegulationsOptions,
  rentEssenseOptions,
} from '../../../../common/constants/options';
import {reverseSign, reverseSignBack} from '../../../../common/utils/form/limitValueLength';
import {uploadingProgress} from '../../../../common/utils/form/uploadingProgress';
import {
  getSharedAndPrivateFiles,
  filterFileListByFileTypeId,
  getFileFolderID
} from '../../utils/fileHelpers';
import {propertyTypesGroups as PT} from '../../constants/propertyTypesGroups';
import ModalPreviewDocument from '../../../../common/components/ModalPreviewDocument';
import ButtonSubmitForm from '../ButtonSubmitForm';
import SpinnerContainer from '../../../../common/components/SpinnerContainer';
import {getOption} from "../../utils/getOption";

const prefilledText = 'חלק הבעלים במקרקעין -\n' +
  'שם מלא חוכר -\n' +
  'תעודת זהות חוכר -\n' +
  'רשום/לא רשום -\n' +
  'תנאי החכירה -\n' +
  'מטרת החכירה -\n' +
  'תקופת החכירה -\n' +
  'דמי החכירה (מהוון/לא מהוון) -\n' +
  'אישור זכויות -';

const fileTypeIds = {
  nesachTabu: T.NESACH_TABU,
  landShituf: T.LAND_SHITUF,
  landHahira: T.LAND_HAHIRA,
  landHafkaa: T.LAND_HAFKAA,
  landHazmada: T.LAND_HAZMADA,
  landZikatHanaa: T.LAND_ZIKAT_HANAA,
  landOther: T.LAND_OTHER,
  tama: T.TAMA,
  purchase: T.PURCHASE,
  rent: T.RENT,
  report: T.REPORT,
};

const Form_1 = ({
                  submitStep,
                  stepData,
                  uploadFile,
                  getShumaStepStatus,
                  appendStepData,
                  showGlobalErrorMessage,
                  getStepData,
                  cities,
                  streets,
                  updateStreets,
                  propertyTypeID,
                  getFileList,
                  filesListData
                }) => {
  useEffect(() => {getFileList({shumaId})}, []);
  const {
    fileList,
    cityID,
    cityName,
    streetID,
    streetName,
    rightsType,
    rightsOwnerName,
    attached,
    floor,
    warningNote,
    displayNoNesachText,
    noKadestritDivide,
    identifyMethodType,
    rightsRegistryDate,
    rightsRegistryRegulationsID,
    joinHomeRegistryDate,
    landShituf,
    landHafkaa,
    landZikatHanaa,
    landHahira,
    landHazmada,
    landOther,
    landShitufText,
    landHafkaaText,
    landHazmadaText,
    landZikatHanaaText,
    landHahiraText,
    landOtherText,
    tama,
    tamaDate,
    tamaSides,
    tamaLand,
    tamaEssence,
    purchase,
    purchaseDate,
    purchaseSigned,
    purchaseSides,
    purchaseSelling,
    purchaseCompensation,
    purchaseDeliveryDate,
    rent,
    rentDate,
    rentEssense,
    rentSides,
    rentRentee,
    rentPurpose,
    rentPeriod,
    rentExtendOptions,
    rentAnnualFeeAmount,
    rentCertificates,
    rentSpecialConditions,
    report,
    reportDate,
    ...rest
  } = stepData;
  const [reinit, setReinit] = useState(true);
  const [progress, setProgress] = useState(0);
  const [showUploadingFilePopUp, setShowUploadingFilePopUp] = useState(false);
  const [loading, setLoading] = useState(false);

  const initialValues = {
    gush: '',
    helka: '',
    ttHelka: '',
    city: Boolean(cityID) ? {label: cityName, value: cityID} : null,
    street: Boolean(streetID) ? {label: streetName, value: streetID} : null,
    houseNumber: '',
    apartmentNumber: '',
    registeredArea: '',
    houseRegisteredArea: 0, //there is no such field in the form, the value is retrieved from the getNesachTabu request
    surveyArea: '',
    file: null,
    entrance: '',
    rightsType: getOption(rightsTypeOptions, rightsType),
    rightsOwnerName: rightsOwnerName || '',
    attached: getOption(attachedOptions, attached),
    sharedParts: '',
    floor: Boolean(floor) ? reverseSignBack(floor) : null,
    attachedText: '',
    warningNote: Boolean(warningNote) || null,
    warningNoteText: '',
    other: '',
    propertyRightsDetails: '',
    displayNoNesachText: Boolean(displayNoNesachText),
    noKadestritDivide: Boolean(noKadestritDivide) || null,
    noKadestritDivideText: '',
    registerDetailsNotes: '',
    rightsPermitCompanyMeshakenet: '',
    rightsPermitRami: '',
    rightsPermitOther: '',
    arnonaVoucher: '',
    rightsChain: '',
    companyDocument: '',
    stopConditionsAppendix: '',
    identifyMethodType: Boolean(identifyMethodType) ? `${identifyMethodType}` : '1',
    rightsRegistryDate: Boolean(rightsRegistryDate) ? new Date(rightsRegistryDate) : null,
    rightsRegistryDesc: '',
    rightsRegistryRegulations: getOption(rightsRegistryRegulationsOptions, rightsRegistryRegulationsID),
    rightsRegistryMortgage: '',
    joinHomeRegistryDate: Boolean(joinHomeRegistryDate) ? new Date(joinHomeRegistryDate) : null,
    joinHomeRegistryRightsType: '',
    joinHomeRegistryOwnerName: '',
    joinHomeRegistryNotes: '',
    joinHomeRegistryMortgage: '',
    propertyLegalDefinition: '',
    landShituf: Boolean(landShituf) || null,
    landHahira: Boolean(landHahira) || null,
    landHafkaa: Boolean(landHafkaa) || null,
    landHazmada: Boolean(landHazmada) || null,
    landZikatHanaa: Boolean(landZikatHanaa) || null,
    landOther: Boolean(landOther) || null,
    landShitufText: landShitufText || '',
    landHahiraText: landHahiraText || prefilledText,
    landHafkaaText: landHafkaaText || '',
    landHazmadaText: landHazmadaText || '',
    landZikatHanaaText: landZikatHanaaText || '',
    landOtherText: landOtherText || '',
    tama: Boolean(tama) || null,
    tamaDate: tamaDate ? new Date(tamaDate) : null,
    tamaSides: tamaSides || '',
    tamaLand: tamaLand || '',
    tamaEssence: tamaEssence || '',
    purchase: Boolean(purchase) || null,
    purchaseDate: purchaseDate ? new Date(purchaseDate) : null,
    purchaseSigned: Boolean(purchaseSigned) || null,
    purchaseSides: purchaseSides || '',
    purchaseSelling: purchaseSelling || '',
    purchaseCompensation: purchaseCompensation || '',
    purchaseDeliveryDate: purchaseDeliveryDate ? new Date(purchaseDeliveryDate) : null,
    rent: Boolean(rent) || null,
    rentDate: rentDate ? new Date(rentDate) : null,
    rentEssense: getOption(rentEssenseOptions, rentEssense),
    rentSides: rentSides || '',
    rentRentee: rentRentee || '',
    rentPurpose: rentPurpose || '',
    rentPeriod: rentPeriod || '',
    rentExtendOptions: rentExtendOptions || '',
    rentAnnualFeeAmount: rentAnnualFeeAmount || '',
    rentCertificates: rentCertificates || '',
    rentSpecialConditions: rentSpecialConditions || '',
    report: Boolean(report) || null,
    reportDate: reportDate ? new Date(reportDate) : null,
    reportText: '',
    landLotNumShituf: '',
    landLotNum: '',
    landLotNumAccordingTaba: '',
    comments: '',

    fileType1Switch: false,
    fileType3Switch: false,
    fileType4Switch: false,
    fileType5Switch: false,
    fileType6Switch: false,
    fileType7Switch: false,
    fileType27Switch: false,
    fileType28Switch: false,
    fileType29Switch: false,
    fileType30Switch: false,

    ...rest
  };

  const nesachTabuFileUploaded = isFileUploaded({fileList: filesListData, fileTypeID: T.NESACH_TABU});
  const landShitufFileUploaded = isFileUploaded({fileList: filesListData, fileTypeID: T.LAND_SHITUF});
  const landHahiraFileUploaded = isFileUploaded({fileList: filesListData, fileTypeID: T.LAND_HAHIRA});
  const landHafkaaFileUploaded = isFileUploaded({fileList: filesListData, fileTypeID: T.LAND_HAFKAA});
  const landHazmadaFileUploaded = isFileUploaded({fileList: filesListData, fileTypeID: T.LAND_HAZMADA});
  const landZikatHanaaFileUploaded = isFileUploaded({fileList: filesListData, fileTypeID: T.LAND_ZIKAT_HANAA});
  const landOtherFileUploaded = isFileUploaded({fileList: filesListData, fileTypeID: T.LAND_OTHER});
  const tamaFileUploaded = isFileUploaded({fileList: filesListData, fileTypeID: T.TAMA});
  const purchaseFileUploaded = isFileUploaded({fileList: filesListData, fileTypeID: T.PURCHASE});
  const rentFileUploaded = isFileUploaded({fileList: filesListData, fileTypeID: T.RENT});
  const reportFileUploaded = isFileUploaded({fileList: filesListData, fileTypeID: T.REPORT});

  const {params: {shumaId, formId: stepId}} = useRouteMatch(P.INSPECTION_AND_FORM_IDS);

  const validate = values => {
    const {
      gush,
      helka,
      city,
      rightsType,
      rightsOwnerName,
      attached,
      sharedParts,
      attachedText,
      warningNoteText,
      noKadestritDivideText,
      landZikatHanaaText,
      landOtherText,
    } = values;

    let errors = checkRequiredValues({
      gush,
      helka,
      city,
      noKadestritDivideText,
      landZikatHanaaText,
      landOtherText
    }, {});

    if (identifyMethodType === 1) {
      errors = checkRequiredValues({
        sharedParts,
        rightsType,
        rightsOwnerName,
        attached
      }, errors)

      if (attached?.value === 1 && !attachedText) {
        errors = checkRequiredValues({attachedText}, errors);
      }
      if (warningNote && !warningNoteText) {
        errors = checkRequiredValues({warningNoteText}, errors);
      }
    }

    return errors;
  };

  const handleNesachFileDownload = ({setFieldValue}) => async dataURI => {
    const file = await getFileFromDataURI({
      dataURI,
      filename: `NESACH_TABU.pdf`
    });
    setFieldValue('file', file);

    return file;
  };

  const submitWithoutFormReinitialization = values => {
    const {
      file,
      city,
      street,
      houseRegisteredArea,
      sharedParts,
      floor,
      displayNoNesachText,
      identifyMethodType,
      fileType1Switch,
      fileType3Switch,
      fileType4Switch,
      fileType5Switch,
      fileType6Switch,
      fileType7Switch,
      fileType27Switch,
      fileType28Switch,
      fileType29Switch,
      fileType30Switch,
      ...rest
    } = values;

    const data = {
      shumaID: shumaId,
      cityID: (city) ? city.value : -1,
      streetID: (street) ? street.value : -1,
      houseRegisteredArea: houseRegisteredArea || 0,
      sharedParts: sharedParts || '',
      floor: reverseSign(floor) || null,
      displayNoNesachText: nesachTabuFileUploaded ? null : displayNoNesachText,
      identifyMethodType: Boolean(identifyMethodType) ? parseInt(identifyMethodType) : 1,
      ...normalizeFormValues(rest),
    };
    setReinit(false);  //https://github.com/formium/formik/issues/2369
    return submitStep({step: 1, data})
      .then(() => setReinit(true));
  };

  const handleDataSubmit = (values, shumaId, dirty) => {
    if (dirty) {
      submitWithoutFormReinitialization(values)
        .then(() => getShumaStepStatus({shumaId, resetValues: false}))
        .catch((err) => showGlobalErrorMessage(err.message));
    }
  };

  const handleSubmitForSharedFiles = formikProps => {
    Promise.resolve()
      .then(() => {
        submitWithoutFormReinitialization(formikProps.values);
      })
      .then(() => getShumaStepStatus({shumaId, resetValues: false}));
  };

  const submitFiles = fileTypeId => (fileToSave, payload) => {
    return uploadFile({shumaId, filename: fileToSave.name, fileTypeId, fileToSave}, payload);
  };

  const handleFileUpload = formikProps => fileTypeId => closeDropdown => (file, payload) => {
    setShowUploadingFilePopUp(true);
    submitFiles(fileTypeId)(file, payload)
      .then(() => uploadingProgress(setProgress))
      .then(() => {
        if (fileTypeId === T.NESACH_TABU) {
          submitWithoutFormReinitialization({
            ...formikProps.values,
            displayNoNesachText: null
          })
        } else {
          submitWithoutFormReinitialization(formikProps.values)
        }
      })
      .then(() => {
        if (closeDropdown) closeDropdown()
      })
      .then(() => getShumaStepStatus({shumaId, resetValues: false}))
      .finally(() => {
        setShowUploadingFilePopUp(false);
        getFileList({shumaId});
        getStepData({shumaId, stepId});
      });
  };

  const handleNesachFileSelected = formikProps => payload => file => {
    const {gush, helka, ttHelka} = formikProps.values;
    appendStepData({...payload, gush, helka, ttHelka});
    setShowUploadingFilePopUp(true);
    handleNesachFileDownload(formikProps)(file)
      .then(file => submitFiles(file))
      .then(() => uploadingProgress(setProgress))
      .then(() => submitWithoutFormReinitialization({
        ...formikProps.values,
        displayNoNesachText: null,
        ...payload
      }))
      .then(() => getShumaStepStatus({shumaId, resetValues: false}))
      .finally(() => {
        setShowUploadingFilePopUp(false);
        getFileList({shumaId});
        getStepData({shumaId, stepId});
      });
  };

  const handleCityChange = formikProps => selected => {
    const {values: {city}, setFieldValue} = formikProps;
    if (!city || city.value !== selected.value) {
      setFieldValue('street', null);
      if (Boolean(selected.value)) {
        updateStreets(selected.value);
      } else {
        handleCityReset(formikProps)();
      }
    }
  };

  const handleCityReset = formikProps => () => {
    const {setFieldValue} = formikProps;
    setFieldValue('street', null);
    setFieldValue('city', null);
  };

  useEffect(() => {
    if (cityID) {
      updateStreets(cityID);
    }
  }, []);

  const getFileSelectOptions = formikProps => {
    const filteredSharedFileID1 = filterFileListByFileTypeId(fileList, fileTypeIds.nesachTabu);
    const filteredSharedFileID3 = filterFileListByFileTypeId(fileList, fileTypeIds.landShituf);
    const filteredSharedFileID4 = filterFileListByFileTypeId(fileList, fileTypeIds.landHahira);
    const filteredSharedFileID5 = filterFileListByFileTypeId(fileList, fileTypeIds.landHafkaa);
    const filteredSharedFileID6 = filterFileListByFileTypeId(fileList, fileTypeIds.landHazmada);
    const filteredSharedFileID7 = filterFileListByFileTypeId(fileList, fileTypeIds.landZikatHanaa);
    const filteredSharedFileID26 = filterFileListByFileTypeId(fileList, fileTypeIds.landOther);
    const filteredSharedFileID27 = filterFileListByFileTypeId(fileList, fileTypeIds.tama);
    const filteredSharedFileID28 = filterFileListByFileTypeId(fileList, fileTypeIds.purchase);
    const filteredSharedFileID29 = filterFileListByFileTypeId(fileList, fileTypeIds.rent);
    const filteredSharedFileID30 = filterFileListByFileTypeId(fileList, fileTypeIds.report);
    const onSubmit = () => handleSubmitForSharedFiles(formikProps);

    return {
      nesachTabu: {
        type: getSharedAndPrivateFiles(filteredSharedFileID1),
        fileTypeID: fileTypeIds.nesachTabu,
        onSubmit,
        folderID: getFileFolderID(filesListData, fileTypeIds.nesachTabu),
      },
      landShituf: {
        type: getSharedAndPrivateFiles(filteredSharedFileID3),
        fileTypeID: fileTypeIds.landShituf,
        onSubmit,
        folderID: getFileFolderID(filesListData, fileTypeIds.landShituf),
      },
      landHahira: {
        type: getSharedAndPrivateFiles(filteredSharedFileID4),
        fileTypeID: fileTypeIds.landHahira,
        onSubmit,
        folderID: getFileFolderID(filesListData, fileTypeIds.landHahira),
      },
      landHafkaa: {
        type: getSharedAndPrivateFiles(filteredSharedFileID5),
        fileTypeID: fileTypeIds.landHafkaa,
        onSubmit,
        folderID: getFileFolderID(filesListData, fileTypeIds.landHafkaa),
      },
      landHazmada: {
        type: getSharedAndPrivateFiles(filteredSharedFileID6),
        fileTypeID: fileTypeIds.landHazmada,
        onSubmit,
        folderID: getFileFolderID(filesListData, fileTypeIds.landHazmada),
      },
      landZikatHanaa: {
        type: getSharedAndPrivateFiles(filteredSharedFileID7),
        fileTypeID: fileTypeIds.landZikatHanaa,
        onSubmit,
        folderID: getFileFolderID(filesListData, fileTypeIds.landZikatHanaa),
      },
      landOther: {
        type: getSharedAndPrivateFiles(filteredSharedFileID26),
        fileTypeID: fileTypeIds.landOther,
        onSubmit,
        folderID: getFileFolderID(filesListData, fileTypeIds.landOther),
      },
      tama: {
        type: getSharedAndPrivateFiles(filteredSharedFileID27),
        fileTypeID: fileTypeIds.tama,
        onSubmit,
        folderID: getFileFolderID(filesListData, fileTypeIds.tama),
      },
      purchase: {
        type: getSharedAndPrivateFiles(filteredSharedFileID28),
        fileTypeID: fileTypeIds.purchase,
        onSubmit,
        folderID: getFileFolderID(filesListData, fileTypeIds.purchase),
      },
      rent: {
        type: getSharedAndPrivateFiles(filteredSharedFileID29),
        fileTypeID: fileTypeIds.rent,
        onSubmit,
        folderID: getFileFolderID(filesListData, fileTypeIds.rent),
      },
      report: {
        type: getSharedAndPrivateFiles(filteredSharedFileID30),
        fileTypeID: fileTypeIds.report,
        onSubmit,
        folderID: getFileFolderID(filesListData, fileTypeIds.report),
      },
    };
  };

  const handleDataSubmitForPreview = (values, shumaId, dirty) => {
    if (dirty) {
      submitWithoutFormReinitialization(values)
        .then(() => getStepData({shumaId, stepId}))
        .then(() => getShumaStepStatus({shumaId, resetValues: false}))
        .catch((err) => showGlobalErrorMessage(err.message));
    }
  };

  const handleDataSubmitForSave = (values, shumaId, dirty) => {
    if (dirty) {
      setLoading(true);
      submitWithoutFormReinitialization(values)
        .then(() => getStepData({shumaId, stepId}))
        .then(() => getShumaStepStatus({shumaId, resetValues: false}))
        .catch((err) => showGlobalErrorMessage(err.message))
        .finally(() => setLoading(false));
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validate={validate}
      onSubmit={() => {
      }}
      enableReinitialize={reinit}
      validateOnChange={true}
      validateOnBlur={false}
    >
      {(formikProps) => (
        <>
          <SilentSubmitHandler
            onSubmit={handleDataSubmit}
            values={formikProps.values}
            shumaId={shumaId}
            dirty={formikProps.dirty}
          />
          <ButtonSubmitForm
            onClick={() => {
              handleDataSubmitForSave(
                formikProps.values,
                shumaId,
                formikProps.dirty
              )
            }}
            disabled={!formikProps.dirty}
          />
          <ModalPreviewDocument
            submitOnOpen={() => {
              handleDataSubmitForPreview(
                formikProps.values,
                shumaId,
                formikProps.dirty
              )
            }}
          />
          {loading ? <SpinnerContainer/> : (
            <Form_1View
              {...formikProps}
              shumaID={shumaId}
              stepID={stepId}
              prevPagePath={P.GET_FORM_BY_ID_AND_STEP(shumaId, 3)}
              nextPagePath={P.GET_FORM_BY_ID_AND_STEP(shumaId, 6)}
              options={{
                cities,
                streets,
                rightsTypeOptions,
                attachedOptions,
                rightsRegistryRegulationsOptions,
                rentEssenseOptions
              }}
              fileUploaded={{
                nesachTabuFileUploaded,
                landShitufFileUploaded,
                landHahiraFileUploaded,
                landHafkaaFileUploaded,
                landHazmadaFileUploaded,
                landZikatHanaaFileUploaded,
                landOtherFileUploaded,
                tamaFileUploaded,
                purchaseFileUploaded,
                rentFileUploaded,
                reportFileUploaded,
              }}
              onFileSelected={handleFileUpload(formikProps)}
              onNesachFileSelected={handleNesachFileSelected(formikProps)}
              fileTypeIds={fileTypeIds}
              cityChangeProps={{
                onChange: handleCityChange(formikProps),
                onReset: handleCityReset(formikProps)
              }}
              showUploadingFilePopUp={showUploadingFilePopUp}
              progress={progress}
              fileSelectOptions={getFileSelectOptions(formikProps)}
              propertyTypes={{
                isLot: PT.LOT.includes(propertyTypeID),
              }}
              fileList={fileList}
              filesListData={filesListData ?? []}
            />
          )}
        </>
      )}
    </Formik>
  );
};

export default Form_1;